var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRoundMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.388 15h13.333a.836.836 0 0 0 .834-.833.836.836 0 0 0-.834-.834H3.388a.836.836 0 0 0-.833.834c0 .458.375.833.833.833zm0-4.167h13.333a.836.836 0 0 0 .834-.833.836.836 0 0 0-.834-.833H3.388a.836.836 0 0 0-.833.833c0 .458.375.833.833.833zm-.833-5c0 .459.375.834.833.834h13.333a.836.836 0 0 0 .834-.834A.836.836 0 0 0 16.72 5H3.388a.836.836 0 0 0-.833.833z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundMenu);
export default __webpack_public_path__ + "static/media/ic-round-menu.b362166ebe273eb53fa2004e9a795e9d.svg";
export { ForwardRef as ReactComponent };